export const baseDateTimeFormats = {
	year: <Intl.DateTimeFormatOptions> {
		year: 'numeric',
	},
	month: <Intl.DateTimeFormatOptions> {
		month: 'long',
	},
	dayAndMonth: <Intl.DateTimeFormatOptions> {
		day: 'numeric',
		month: 'long',
	},
	yearAndMonth: <Intl.DateTimeFormatOptions> {
		year: 'numeric',
		month: 'long',
	},
	yearAndMonthAndDay: <Intl.DateTimeFormatOptions> {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	},
	short: <Intl.DateTimeFormatOptions> {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	},
	long: <Intl.DateTimeFormatOptions> {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
		timeZoneName: 'short',
	},
	longNoTz: <Intl.DateTimeFormatOptions> {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric',
		hour12: true,
	},
	timeShortNoTz: <Intl.DateTimeFormatOptions> {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
	},
	timeShort: <Intl.DateTimeFormatOptions> {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
		timeZoneName: 'short',
	},
};
